import {createSecureUuid} from "../helper/secureUuid";

// Retry identities for paid legacy Email requests whose outcome is unknown.
// The backend scopes each key to account + user, so a key can never be
// replayed into another tenant (alphasearch-io/Alphasearch-Backend#737).
const pendingKeys = new Map();

function splitReplayHeader(config) {
  const headers = config.headers?.toJSON?.() || config.headers || {};
  let key;
  const rest = {};
  Object.entries(headers).forEach(([name, value]) => {
    if (name.toLowerCase() === "idempotency-key") key = value;
    else rest[name] = value;
  });
  return {key, rest};
}

// A lost response, a server error or a still-running duplicate may mean the
// first request was accepted and charged; only a retry with the same key can
// recover that result instead of paying again.
function outcomeUncertain(error) {
  const status = error?.response?.status;
  if (!status || status >= 500) return true;
  return status === 409 && error.response.data?.detail?.code === "legacy_email_execution_started";
}

export async function postLegacyEmail(post, path, payload, config = {}) {
  const {key: callerKey, rest} = splitReplayHeader(config);
  const identity = `${path}\n${JSON.stringify(payload)}`;
  const key = callerKey ?? pendingKeys.get(identity) ?? createSecureUuid();
  if (callerKey === undefined) pendingKeys.set(identity, key);
  // An older concurrent response must not retire a newer operation's identity.
  const clearOwnedKey = () => {
    if (callerKey === undefined && pendingKeys.get(identity) === key) pendingKeys.delete(identity);
  };
  try {
    const response = await post(path, payload, {...config, headers: {...rest, "Idempotency-Key": key}});
    clearOwnedKey();
    return response;
  } catch (error) {
    if (!outcomeUncertain(error)) clearOwnedKey();
    throw error;
  }
}
